module.exports = __webpack_public_path__ + "img/18.0c82824c.jpg";